import { CloseOutlined, DeleteOutlined } from "@ant-design/icons"
import { Button, Modal, Tabs, Form, Input, Select, DatePicker, ConfigProvider, Radio, } from "antd"

import viVN from 'antd/locale/vi_VN';

const { TextArea } = Input;

interface ModalProps {
    isOpen: boolean
    onConfirm?: () => void
    closeModal: () => void
}
const ModalAddSupportHistory: React.FC<ModalProps> = ({
    isOpen, onConfirm, closeModal
}) => {

    const [form] = Form.useForm();


    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Tạo thông tin hỗ trợ, khiếu nại</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
            </div>}
            open={isOpen}
            onCancel={closeModal}
            centered
            className="custom-modal-ant-history"
            style={{
                width: '100%'
            }}
            closeIcon={false}
            footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2  w-full border-t-F0F0F0">
                <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
                    <Button onClick={closeModal}>Huỷ</Button>
                    <Button type="primary">Lưu</Button>
                </div>
            </div>}
        >
            <div className=" custom-page-css flex flex-col  h-full  ">
                <Form
                    form={form}
                    layout="vertical"
                    className="mt-4 custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-4"

                >
                    <Radio.Group
                        //  onChange={handleModeChange} value={mode}
                        defaultValue={'feedback'}
                        style={{ marginBottom: 8 }}>
                        <Radio.Button value="complaint">Khiếu nại</Radio.Button>
                        <Radio.Button value="feedback">Phàn nàn</Radio.Button>
                    </Radio.Group>
                    {/* Row 1 */}
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Ngày ghi nhận" name="receivedDate">
                            <ConfigProvider locale={viVN}>
                                <DatePicker className="w-full" format="DD/MM/YYYY" />
                            </ConfigProvider>
                        </Form.Item>

                        <Form.Item label="Kênh tiếp nhận" name="channel">
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Kênh tiếp nhận" />
                        </Form.Item>
                    </div>

                    {/* Row 2 */}
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Trạng thái kết thúc xử lý" name="status">
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Trạng thái kết thúc xử lý" />
                        </Form.Item>

                        <Form.Item label="Ngày kết thúc" name="endDate">
                            <ConfigProvider locale={viVN}>
                                <DatePicker className="w-full" format="DD/MM/YYYY" />
                            </ConfigProvider>
                        </Form.Item>
                    </div>

                    {/* Row 3 */}
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Biển số xe" name="plate">
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Biển số xe" />
                        </Form.Item>

                        <Form.Item label="Số khung" name="vin">
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Số khung" />
                        </Form.Item>
                    </div>

                    {/* Row 4 */}
                    <div className="grid grid-cols-2 gap-4">
                        <Form.Item label="Phân loại cấp 1" name="categoryLv1">
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Phân loại cấp 1" />
                        </Form.Item>

                        <Form.Item label="Phân loại cấp 2" name="categoryLv2">
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Phân loại cấp 2" />
                        </Form.Item>
                    </div>

                    {/* Row 5 */}
                    <div className="grid grid-cols-3 gap-4">
                        <Form.Item label="Nhân viên xử lý" name="staff" >
                            <Select
                                className="custom-page-css border rounded"
                                defaultValue="Mỹ Trần (NV91284)"
                                options={[
                                    { value: 'my-tran', label: 'Mỹ Trần (NV91284)' }
                                ]}
                            />
                        </Form.Item>

                        <Form.Item label="Đơn vị tiếp nhận" name="unit" >
                            <Select
                                className="custom-page-css border rounded"
                                defaultValue="THACO AUTO TP.HCM"
                                options={[
                                    { value: 'thaco-hcm', label: 'THACO AUTO TP.HCM' }
                                ]}
                            />
                        </Form.Item>

                        <Form.Item label="Điểm bán hàng" name="salePoint" >
                            <Select
                                className="custom-page-css border rounded"
                                placeholder="Điểm bán hàng"
                                options={[
                                    { value: 'thaco-hcm', label: 'THACO AUTO TP.HCM' }
                                ]}
                            />

                        </Form.Item>
                    </div>

                    {/* Nội dung */}
                    <Form.Item label="Nội dung" name="content">
                        <TextArea
                            rows={4}
                            placeholder="Nhập nội dung trao đổi"
                        />
                    </Form.Item>

                    {/* Giải pháp */}
                    <Form.Item label="Giải pháp" name="solution">
                        <TextArea
                            rows={4}
                            placeholder="Nhập giải pháp"
                        />
                    </Form.Item>
                    <Form.Item label="Tình trạng hiện tại lần 1:" name="status1">
                        <TextArea
                            rows={4}
                            placeholder="Tình trạng hiện tại lần 1"
                        />
                    </Form.Item>

                    <Form.Item label="Ghi chú:" name="note">
                        <TextArea
                            rows={4}
                            placeholder="Nhập ghi chú"
                        />
                    </Form.Item>

                </Form>
            </div>
        </Modal>
    )
}
export default ModalAddSupportHistory
